import { WistiaPlayer } from '@wistia/wistia-player-react';
import extractAttributes from '../Image/utils/extractAttributes';

type WistiaProps = {
  video: string;
  height: number;
  width: number;
};

export default function Wistia({ video, height, width }: WistiaProps) {
  return <WistiaPlayer mediaId={video} height={height} width={width} />;
}

export function getWistiaProps(html: string): WistiaProps {
  const attrs = extractAttributes(html);
  const height = parseInt(attrs.height ?? '500', 10);
  const width = parseInt(attrs.width ?? '800', 10);
  const video = attrs.video ?? '';

  return {
    height,
    width,
    video,
  };
}
